import React from "react";
import styled from "styled-components";

const LoaderWrapper = styled.div`
  position: absolute;
  max-height: 60vmin;
  max-width: 60vmin;
  height: 40px;
  width: 40px;
  top: 50%;
  left: 50%;
  transform: translateX(-50%) translateY(-50%);
  z-index: 10;

  .loader {
    height: 100%;
    width: 100%;
    box-sizing: border-box;
    border: 3px solid rgba(0, 0, 0, 0.2);
    border-top-color: rgba(33, 128, 192, 0.8);
    border-radius: 100%;
    animation: rotation 0.7s infinite linear;
  }

  @keyframes rotation {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(359deg);
    }
  }
`;

const Loader = () => {
  return (
    <LoaderWrapper>
      <div className="loader" />
    </LoaderWrapper>
  );
};

export default Loader;
